module.exports = ".name-class {\r\n    color: blue;\r\n}"